import { useTranslation } from 'next-i18next/pages';
import { type RestrictedListing } from '@pkgs/api/models';
import { Modal, useModalState } from '@ev-tech/ui-core-components/Modal';
import { IconButton } from '@ev-tech/ui-core-components/IconButton';
import { Headline } from '@ev-tech/ui-core-components/Headline';
import { Button } from '@ev-tech/ui-core-components/Button';

import { CrossNaked } from '@/icons/small/CrossNaked';
import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { PadlockIcon } from '@/components/common/Icons/PadlockIcon';

import { RequestAccessForm } from '../../RequestAccessForm/RequestAccessForm';
import { ModalContext } from '../../Modal/ModalContext';

import styles from './PropertyLockedInfoCard.module.css';
import modalStyles from '../../ContactForm/components/Modal.module.css';

export const PropertyLockedInfoCard = ({ restrictedListing }: { restrictedListing: RestrictedListing }): React.ReactElement => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.private_office);
  const { t: tCommon } = useTranslation(TRANSLATION_NAMESPACE.common);
  const { isOpen, setOpen, close, open } = useModalState();

  return (
    <>
      <div className={styles.container} data-testid="property-locked-info-card">
        <PadlockIcon />
        <Headline label={t('search.expose.listing.locked.title')} as="h1" size="h4" />
        <p className={styles.text}>{t('search.expose.listing.locked.text')}</p>
        <Button className={styles.button} onClick={() => open()} label={t('search.request.access.form.button.send')} size="medium" />
      </div>
      <Modal modal open={isOpen} onOpenChange={setOpen}>
        <ModalContext.Provider value={{ isModal: true, close: () => close() }}>
          <div className={modalStyles.modal}>
            <div className={modalStyles.topBar}>
              <IconButton icon={<CrossNaked />} variant="tertiaryAlt" onClick={close} label={tCommon('header.navigation.button.close')} />
            </div>
            <div data-testid="page-modal-content" className={modalStyles.content}>
              <RequestAccessForm restrictedListing={restrictedListing} />
            </div>
          </div>
        </ModalContext.Provider>
      </Modal>
    </>
  );
};
